import axios from 'axios';
import {getBuildNumber,getVersion} from 'react-native-device-info';
import { isNetworkAvailable } from '../../hooks/useConnection';
import { useAppPersistenceStore } from '../../store/useAppPersistenceStore';
import { useProfileStore } from '../../store/useProfileStore';
import { handleRetry } from '../../utils/handleRetry';
import { getKisaanBaseURL } from '../paths';
import { Platform } from 'react-native';
import { webBuildNumber } from '@ninjacart/nc-nk-core';
export const KisaanClient = axios.create({
  baseURL: getKisaanBaseURL(),
  timeout: 60000,
  headers: {
    Accept: 'application/json',
    'x-build-number': Platform.OS === 'web' ? webBuildNumber : Number(getBuildNumber()),
    'x-platform': Platform.OS,
    'x-version-code': getVersion(),
    'x-language-code': useAppPersistenceStore?.getState()?.appLanguage,
    ...(useProfileStore.getState().userProfile?.access_token && {
      Authorization: `Bearer ${useProfileStore.getState().userProfile?.access_token}`,
    }),
    ...(useProfileStore.getState()?.streamConfig?.access_token && {
      'x-peertube-auth': `Bearer ${useProfileStore.getState()?.streamConfig?.access_token}`,
    }),
    ...(useProfileStore.getState()?.feedConfig && {
      'x-feed-auth': `Bearer ${useProfileStore.getState()?.feedConfig}`,
    }),
    ...(Platform.OS !== 'web' && { 'Accept-Encoding': 'gzip' }),
  },
});

KisaanClient.interceptors.request.use(async (config) => {
  const isConnected = isNetworkAvailable();
  if (!isConnected) {
    return Promise.reject('No internet available!!!');
  }

  if (useProfileStore?.getState()?.userProfile?.access_token) {
    config.headers.Authorization = `Bearer ${useProfileStore.getState().userProfile?.access_token}`;
  }

  if (useProfileStore?.getState()?.streamConfig?.access_token) {
    config.headers['x-peertube-auth'] =
      `Bearer ${useProfileStore.getState()?.streamConfig?.access_token}`;
  }

  if (useProfileStore?.getState()?.feedConfig) {
    config.headers['x-feed-auth'] = `Bearer ${useProfileStore.getState().feedConfig}`;
  }

  config.headers['x-language-code'] = useAppPersistenceStore?.getState()?.appLanguage;
  config.headers['x-device-id'] = useAppPersistenceStore.getState()?.deviceId ?? '';
  // config.headers["x-mastodon-auth"]=createProfStore.getState()?.feedConfig?`Bearer ${createProfStore.getState()?.feedConfig}`:''
  return Promise.resolve(config);
});
// Response interceptor to handle retries
KisaanClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;
    if (error.response?.status === 401) {
      return Promise.reject(config);
    }
    return handleRetry(error, config, 'KISANCLIENT_API_FAILED', KisaanClient);
  }
);
